import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';

import React, { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text/index';

import Global from '../../../store/global-selectors';
import { LocaleContext } from '../../../intl/locale-context-provider';
import { getLink } from '../../../services/link-service';
import { linkIDs } from '../../../services/link-service/links';
import { DEFAULT_ORDERS_PAGE_URL } from '../../../services/user-permission-service';
import { REFUND_ASSIST_VIEW_ID } from '../../../components/shipping-grid/views/view-id-constants';

import messages from './messages';
import style from '../../grid-page.module.less';

const ShipmentsGridPlaceholder = () => {
  const history = useHistory();
  const location = useLocation();
  const { locale } = useContext(LocaleContext);
  const homeCountry = useSelector(Global.selectSellerHomeCountry);

  const isRefundAssistView = location?.pathname?.includes(REFUND_ASSIST_VIEW_ID);

  const kbLink = getLink(linkIDs.RefundAssist, homeCountry, locale);

  const action = useCallback(() => {
    history.push(DEFAULT_ORDERS_PAGE_URL);
  }, [history]);

  return (
    <ActionablePlaceholder
      action={action}
      actionDescription={
        (!isRefundAssistView && (
          <FormattedMessage
            {...messages.actionDescription}
            values={{
              link: (
                <Button onClick={action} theme='link'>
                  <FormattedMessage {...messages.link} />
                </Button>
              ),
            }}
          />
        )) ||
        (isRefundAssistView && (
          <Button className={style.learnMoreLink} href={kbLink} rel='noreferrer' target='_blank' theme='link'>
            <Text textType={TextType.Paragraph} value={messages.learnMoreAboutRefundAssist} />
            <FontAwesomeIcon className={style.learnMoreIcon} icon={faArrowUpRightFromSquare} />
          </Button>
        ))
      }
      buttonContent={!isRefundAssistView && <FormattedMessage {...messages.buttonContent} />}
      description={
        isRefundAssistView ? (
          <FormattedMessage {...messages.refundAssistGridEmptyStateDescription} />
        ) : (
          <FormattedMessage {...messages.description} />
        )
      }
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                {isRefundAssistView ? (
                  <FormattedMessage {...messages.refundAssistStatusViewText} />
                ) : (
                  <FormattedMessage {...messages.boldStatusView} />
                )}
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default ShipmentsGridPlaceholder;
